/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBookmarksFilled = createReactComponent("filled", "bookmarks-filled", "IconBookmarksFilled", [["path", { "d": "M12 6a4 4 0 0 1 4 4v11a1 1 0 0 1 -1.514 .857l-4.486 -2.691l-4.486 2.691a1 1 0 0 1 -1.508 -.743l-.006 -.114v-11a4 4 0 0 1 4 -4h4z", "key": "svg-0" }], ["path", { "d": "M16 2a4 4 0 0 1 4 4v11a1 1 0 0 1 -2 0v-11a2 2 0 0 0 -2 -2h-5a1 1 0 0 1 0 -2h5z", "key": "svg-1" }]]);

export { IconBookmarksFilled as default };
//# sourceMappingURL=IconBookmarksFilled.mjs.map
